module.exports = __webpack_public_path__ + "static/img/icon_codewb.64b836df.jpg";